import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-052f655a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = { class: "p-m-0" }
const _hoisted_3 = {
  style: {"width":"auto"},
  class: "p-inputgroup"
}
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1))

import { computed, defineAsyncComponent, reactive } from "vue";
import CreateCustomer from "@/components/customer/CustomerCreate.vue";
import { useDeleteCustomer } from "@/graphql/customer/delete.customer";
import { usePaginateCustomers } from "@/graphql/customer/paginate.customers";
import { useCustomerPermissions } from "@/hooks/permissions/useCustomerPermission";


export default /*#__PURE__*/_defineComponent({
  __name: 'Customer',
  setup(__props) {

const UpdateCustomer = defineAsyncComponent(
  () => import("@/components/customer/CustomerUpdate.vue")
);

const update = reactive({
  item: null,
  show: false,
});
const { canDelete, canUpdate } = useCustomerPermissions();
const { submitDelete, loadingDelete } = useDeleteCustomer();
const { loading, customers, input, submitSearch, filters, clearFilter } =
  usePaginateCustomers();
const cannotDelete = computed(() => !canDelete || loadingDelete.value);

function openUpdate(item: any) {
  update.item = item;
  update.show = true;
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      style: {"max-height":"calc(100vh - 150px)"},
      value: _unref(customers).items,
      class: "p-datatable-customers p-datatable-sm",
      rows: _unref(customers).meta.itemsPerPage,
      dataKey: "id",
      rowHover: false,
      filterDisplay: "menu",
      loading: _unref(loading),
      responsiveLayout: "scroll",
      globalFilterFields: ['name', 'phone', 'email']
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("customer.customers")), 1),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _unref(filters).global.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).global.value) = $event)),
              placeholder: _ctx.$t('search'),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(submitSearch)('global')), ["enter"]))
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(submitSearch)('global'))),
              label: _ctx.$t('search'),
              type: "submit",
              icon: "pi pi-search"
            }, null, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-filter-slash",
            label: _ctx.$t('clear'),
            class: "p-button-outlined p-mb-1",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(clearFilter)())),
            style: {"margin":"5px"}
          }, null, 8, ["label"]),
          _createVNode(CreateCustomer)
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("customer.noData")), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Paginator, {
          rows: _unref(input).limit,
          "onUpdate:rows": _cache[4] || (_cache[4] = ($event: any) => ((_unref(input).limit) = $event)),
          totalRecords: _unref(customers).meta.totalItems,
          rowsPerPageOptions: [20, 30, 50, 100],
          onPage: _cache[5] || (_cache[5] = ($event: any) => (_unref(input).page = $event.page + 1))
        }, null, 8, ["rows", "totalRecords"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('customer.customerName'),
          "show-add-button": false,
          showFilterOperator: false,
          filterField: "name",
          style: {"min-width":"14rem"},
          sortable: true,
          "sort-field": "name"
        }, {
          body: _withCtx(({ data }) => [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(data.name), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              onKeyup: ($event: any) => (filterCallback()),
              placeholder: _ctx.$t('customer.filterByName')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              label: _ctx.$t('clear_'),
              class: "p-button-warning"
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (_unref(submitSearch)('name', filterCallback)),
              class: "p-button-success"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "phone",
          header: _ctx.$t('customer.phone'),
          style: {"min-width":"14rem"},
          "show-add-button": false,
          showFilterOperator: false,
          filterField: "phone",
          sortable: true,
          "sort-field": "phone"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              onKeyup: ($event: any) => (filterCallback()),
              placeholder: _ctx.$t('customer.filterByPhone')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              label: _ctx.$t('clear_'),
              class: "p-button-warning"
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('search'),
              onClick: ($event: any) => (_unref(submitSearch)('phone', filterCallback)),
              class: "p-button-success"
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "email",
          header: _ctx.$t('customer.email'),
          style: {"min-width":"14rem"},
          "show-add-button": false,
          showFilterOperator: false,
          filterField: "email",
          sortable: true,
          "sort-field": "email"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              onKeyup: ($event: any) => (filterCallback()),
              placeholder: _ctx.$t('customer.filterByEmail')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              label: _ctx.$t('clear_'),
              class: "p-button-warning"
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('search'),
              onClick: ($event: any) => (_unref(submitSearch)('email', filterCallback)),
              class: "p-button-success"
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "address",
          header: _ctx.$t('customer.address'),
          style: {"min-width":"14rem"},
          "show-add-button": false,
          showFilterOperator: false,
          filterField: "address",
          sortable: true,
          "sort-field": "address"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              onKeyup: ($event: any) => (filterCallback()),
              placeholder: _ctx.$t('customer.filterByAddress')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              label: _ctx.$t('clear_'),
              class: "p-button-warning"
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('search'),
              onClick: ($event: any) => (_unref(submitSearch)('address', filterCallback)),
              class: "p-button-success"
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "createdAt",
          "show-add-button": false,
          showFilterOperator: false,
          header: _ctx.$t('createdAt'),
          dataType: "date",
          style: {"min-width":"8rem"},
          "filter-field": "createdAt",
          sortable: true,
          "sort-field": "createdAt"
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              dateFormat: _ctx.$t('format.calendarDate'),
              placeholder: _ctx.$t('format.date'),
              "year-navigator": true,
              onDateSelect: ($event: any) => (filterCallback())
            }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder", "onDateSelect"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              "icon-pos": "right",
              label: _ctx.$t('search'),
              type: "button",
              icon: "pi pi-database",
              class: "p-button-sm",
              onClick: ($event: any) => (_unref(submitSearch)('createdAt', filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('controls'),
          style: {"min-width":"14rem"}
        }, {
          body: _withCtx(({ data }) => [
            _withDirectives(_createVNode(_component_Button, {
              type: "submit",
              class: "p-button-rounded p-button-success",
              icon: "pi pi-pencil",
              disabled: !_unref(canUpdate),
              style: {"margin":"5px"},
              onClick: ($event: any) => (openUpdate(data))
            }, null, 8, ["disabled", "onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('save'),
                void 0,
                { bottom: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              class: "p-button-rounded p-button-danger",
              icon: "pi pi-trash",
              style: {"margin":"5px"},
              disabled: cannotDelete.value,
              onClick: (e) => _unref(submitDelete)(e, data.id)
            }, null, 8, ["disabled", "onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('remove'),
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading"]),
    (update.show)
      ? (_openBlock(), _createBlock(_unref(UpdateCustomer), {
          key: 0,
          modelValue: update.show,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((update.show) = $event)),
          customer: update.item
        }, null, 8, ["modelValue", "customer"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})